module.exports = __webpack_public_path__ + "public/img/防火巡查.15e20a86.png";